<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo stopnjo davka:
    </h2>

    <TaxLevelForm
      @save="save"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import TaxLevelForm from '@/components/TaxLevelForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    TaxLevelForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('taxLevels', ['saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyTaxLevels', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyTaxLevels' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
